<template>
  <el-dialog
    title="添加门店"
    width="1330px"
    :visible="visible"
    @close="close"
    :close-on-click-modal="false"
    append-to-body
  >
    <div class="mb10 flex flex-between">
      <!-- <div>按组织架构</div> -->
      <el-radio-group
        v-model="searchCondition.statusType"
        size="small"
        @change="statusTypeChange"
      >
        <!-- <el-radio-button label="organization">按组织架构</el-radio-button> -->
        <!-- <el-radio-button label="role">按角色</el-radio-button> -->
        <el-radio-button label="organization">按组织架构</el-radio-button>
        <el-radio-button label="region">按区域</el-radio-button>
        <el-radio-button label="type">按类型</el-radio-button>
        <el-radio-button label="guider">按督导</el-radio-button>
      </el-radio-group>
      <div style="padding-right:25px;display:flex;align-items:center;">
           <!-- <el-button type="primary" size="small" @click="innerVisible=true"
              >新增职员</el-button
            > -->
            <div style="margin-right:20px;color:#999999;"><span v-if="latestUpdateTime!=''">最近更新时间：{{latestUpdateTime}}</span><el-button style="margin-left:10px" type="text" :loading="isLoading" icon="el-icon-refresh" @click="refreshStore">刷新</el-button></div>
            <el-button type="primary" size="small" @click="handleConfirmExport"
              >导出</el-button
            >
        </div>
    </div>
    <div class="bd1 flex" style="width:1200px">
      <div class="left">
        <el-scrollbar style="height: 100%" class="page-component__scroll">
          <div class="all node pointer" @click="searchAll">全部</div>
          <side-emp-item
            :active="active"
            @check="check"
            :list="tableData"
          ></side-emp-item>
        </el-scrollbar>
      </div>
      <div class="flex-1 p10" style="width: 907px;">
        <div class="mb10 flex flex-between mt10">
          <!-- <el-button type="primary" size="small" @click="addemp"
            >新增职员</el-button
          > -->
          <div>
            <el-input
              clearable
              style="width: 250px"
              v-model.trim="searchCondition.queryKey"
              placeholder="请输入门店名称 "
              size="small"
              class="ipt mr10"
            ></el-input>
            <el-button type="primary" size="small" @click="search"
              >查询</el-button
            >
          </div>
        </div>
        <div v-if="selectType === 'multiple'">
          <el-table
            max-height="440"
            @selection-change="getChecked"
            :data="list"
            style="width: 100%"
            stripe
            size="small"
            border
          >
            <el-table-column type="selection"></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="index => index + (currentPage - 1) * pageSize + 1"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="企微名称"
              show-overflow-tooltip
              prop="wecomDeptName"
              column-key="wecomDeptName"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="企微ID"
              show-overflow-tooltip
              prop="wecomDeptId"
              column-key="wecomDeptId"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="MOP门店名称"
              prop="mopCompanyName"
              column-key="mopCompanyName"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="MOP门店CODE"
              prop="mopCompanyCode"
              column-key="mopCompanyCode"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="MOP门店ID"
              prop="mopCompanyId"
              column-key="mopCompanyId"
            ></el-table-column>
          </el-table>
        </div>
        <div v-else>
          <div
            class="mb10 flex flex-start item-center"
            v-if="recordList.length"
          >
            最近选择：
            <el-tag
              size="small"
              class="pointer"
              type="info"
              closable
              v-for="(v, i) in recordList"
              :key="i"
              @click="seleckEmp(v)"
              @close="del(v)"
              >{{ v.realname }}</el-tag
            >
          </div>
          <div class="tips">提示：点击表格行即可选择</div>
          <el-table
            max-height="440"
            highlight-current-row
            @current-change="handleCurrentChange"
            :data="list"
            style="width: 100%"
            stripe
            size="small"
            border
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="index => index + (currentPage - 1) * pageSize + 1"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="企微名称"
              show-overflow-tooltip
              prop="wecomDeptName"
              column-key="wecomDeptName"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="企微ID"
              show-overflow-tooltip
              prop="wecomDeptId"
              column-key="wecomDeptId"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="MOP门店名称"
              prop="mopCompanyName"
              column-key="mopCompanyName"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="MOP门店CODE"
              prop="mopCompanyCode"
              column-key="mopCompanyCode"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="MOP门店ID"
              prop="mopCompanyId"
              column-key="mopCompanyId"
            ></el-table-column>
          </el-table>
        </div>
        <!-- v-if="searchCondition.statusType === 'organization'" -->
        <!-- <div
          class="hm-pagination"
        >
          <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChange"
            :page-sizes="[10, 50, 100, 200]"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div> -->
      </div>
    </div>
    <div slot="footer" class="dialog-footer flex flex-center">
      <el-button @click="add" type="primary" size="small">确认选择</el-button>
      <el-button @click="close" type="info" size="small">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import SideEmpItem from "@/components/SideEmpItem";
import Bus from "@/utils/bus.js";
import { getLoginUser } from "@/utils/auth";
import { request } from "@/utils/request";
import { arrayUnique2 } from "@/utils/utils";
// import { queryActivityCategory } from "@/utils/utils";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    selectType: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  components: { SideEmpItem },
  data() {
    const validatorOrgCodesFunc = function(rule, val, callback) {
      if (this.isArray(val)) {
        if (val.length <= 0) {
          return callback(new Error("请选择所属机构"));
        }
      } else {
        if (val === "") {
          return callback(new Error("请选择所属机构"));
        }
      }

      // if (this.ruleForm.password === this.ruleForm.confirmpassword) {
      //   callback();
      // } else {
      //
      // }
      callback();
    }.bind(this);
    const validatorFunc = function(rule, val, callback) {
      if (
        this.detailsRuleForm.password === this.detailsRuleForm.confirmpassword
      ) {
        callback();
      } else {
        return callback(new Error("两次输入密码不一致"));
      }
    }.bind(this);
    const checkPhone = function(rule, val, callback) {
      if (/^1[0-9]{10}$/.test(val)) {
        request({
          url: `/sys/duplicate/check`,
          method: "get",
          params: {
            tableName: "store_user",
            fieldName: "phone",
            fieldVal: val,
            dataId: this.userId
          }
        })
          .then(() => {
            callback();
          })
          .catch(() => {
            return callback(new Error("手机号已存在"));
          });
      }
    }.bind(this);
    const checkUsername = (rule, val, callback) => {
      if (val) {
        request({
          url: `/sys/duplicate/check`,
          method: "get",
          params: {
            tableName: "store_user",
            fieldName: "username",
            fieldVal: val
          }
        })
          .then(() => {
            callback();
          })
          .catch(() => {
            return callback(new Error("用户名已存在"));
          });
      }
    };
    return {
      recordList: [],
      roleAllList: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryOrganizationTree", {
                pageNo: 1,
                pageSize: 999,
                loginType: "store"
              })
              .then(res => {
                res.result.records.forEach(v => {
                  v.leaf = Boolean(!v.isParent);
                  v.value = v.orgCode;
                  v.label = v.departName;
                });
                resolve(res.result.records);
              });
          } else {
            this.$store
              .dispatch("queryOrganizationListByParent", {
                parentId: data.treeStruct,
                loginType: "store"
              })
              .then(res => {
                if (res.code === "0" && res.result) {
                  res.result.forEach(v => {
                    v.leaf = Boolean(!v.isParent);
                    v.value = v.orgCode;
                    v.label = v.departName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      innerVisible: false,
      active: "",
      total: 0,
      currentPage: 1,
      pageSize: 10,
      list: [],
      organizationList: [],
      activeIndex: "2",
      roleList: [],
      tableData: [],
      searchCondition: {
        statusType: "organization"
      },
      data: {},
      orgCode: "",
      target: {},
      currentRow: {},
      checkedRowList: [],
      roleId: "",
      detailsRuleForm: {
        username: "",
        realname: "",
        password: "",
        confirmpassword: "",
        phone: "",
        context: "",
        workNum: "",
        birthday: "",
        sex: "",
        regDay: "",
        workingState: "",
        isManager: "",
        ruleLists: [],
        orgCodes: [],
        address: ""
        // username: "",
        // password: "",
        // confirmpassword: "",
        // realname: "",
        // birthday: "",
        // sex: "",
        // email: "",
        // phone: "",
        // avatar:
        //   "https://imgcdn.hemiao100.com/hemiaoBase/ce9c2cec-bead-43a0-9de3-2bc3e9e16acb.png"
      },
      detailsRules: {
        username: [
          {
            required: true,
            message: "请输入用户账号！",
            trigger: "blur"
          },
          {
            max: 12,
            message: "长度应小于12个字符",
            trigger: "blur"
          },
          {
            validator: checkUsername,
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "请输入密码!",
            trigger: "blur"
          },
          { min: 8, max: 12, message: "长度在8到12个字符", trigger: "blur" },
          {
            message: "只能输入数字或字母或数字与字母的组合",
            pattern: /^[0-9a-zA-Z]*$/g,
            trigger: "blur"
          }
        ],
        confirmpassword: [
          {
            required: true,
            validator: validatorFunc,
            trigger: "blur"
          },
          { min: 8, max: 12, message: "长度在8到12个字符", trigger: "blur" },
          {
            message: "只能输入数字或字母或数字与字母的组合",
            pattern: /^[0-9a-zA-Z]*$/g,
            trigger: "blur"
          }
        ],
        orgCodes: {
          required: true,
          validator: validatorOrgCodesFunc,
          message: "请选择所属机构"
        },
        ruleLists: {
          required: true,
          message: "请选择角色"
        },
        workNum: {
          required: true,
          trrger: "blur",
          message: "请输入工号"
        },
        workingState: {
          required: true,
          message: "请选择在职状态"
        },
        isManager: {
          required: true,
          message: "请选择是否主管"
        },
        // phone: [
        //   {
        //     required: true,
        //     trrger: "blur",
        //     message: "请输入手机号"
        //   },
        //   {
        //     required: true,
        //     pattern: /^1[0-9]{10}$/,
        //     message: "请输入正确的手机号",
        //     trigger: "blur"
        //   }
        // ],
        realname: [
          {
            required: true,
            message: "请输入用户名称！",
            trigger: "blur"
          },
          {
            max: 12,
            message: "长度应小于12个字符",
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            pattern: /^1[0-9]{10}$/,
            message: "请输入正确的手机号",
            trigger: "blur"
          },
          {
            validator: checkPhone,
            trigger: "blur"
          }
        ]
      },
      storeCode: "",
      checkItem: null,
      paramsCondition: {},
      // 更新门店列表
      isLoading:false,
      latestUpdateTime:''
    };
  },
  computed: {},
  watch: {},
  created() {
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    // Bus.$on("check", target => {
    //   log
    //   this.currentRow = {};
    //   if (this.searchCondition.statusType === "organization") {
    //     if (target.orgCode != this.orgCode) {
    //       this.check(target);
    //     }
    //   } else {
    //     if (target.roleId != this.roleId) {
    //       this.check(target);
    //     }
    //   }
    // });
    Bus.$on("check", (val, deptList, list) => {
      console.log('searchCondition.statusType', this.searchCondition.statusType);
      console.log("---check---", val, deptList, list);
      if(this.searchCondition.statusType === "organization") {
        this.$set(this,'paramsCondition', {deptIds: list.map(item => item.wecomDeptId)})
      } else if(this.searchCondition.statusType === "region") {
        this.$set(this,'paramsCondition', {mopMerchantsAreaNames: list.map(item => item.mopMerchantsAreaName)})
      } else if (this.searchCondition.statusType === "type") {
        this.$set(this,'paramsCondition', {mopJoiningTraderNames: list.map(item => item.mopJoiningTraderName)})
      } else {
        this.$set(this,'paramsCondition', {mopSupervisorNames: list.map(item => item.mopSupervisorName)})
      }
      this.check()
    })
  },
  mounted() {
    this.queryStoreDepartInfoList();
    this.queryList();
    // this.queryAllRoleList();
    // this.queryOkrLeaderChoiceRecordList();
  },
  methods: {
    addemp() {
      this.queryRoleList();
      this.innerVisible = true;
      // setTimeout(() => {
      //   this.$refs.detailsRuleForm.resetFields();
      // }, 1000);
      this.$nextTick(() => {
        this.$refs.detailsRuleForm.resetFields();
      });
    },
    async del(v) {
      const { code } = await this.$store.dispatch(
        "delOkrLeaderChoiceRecord",
        v
      );
      if (code === "0") {
        this.$message({
          message: " 操作成功",
          type: "success"
        });
        this.queryOkrLeaderChoiceRecordList();
      }
    },
    handleClose() {
      this.innerVisible = false;
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    // async queryAllRoleList() {
    //   const params = {
    //     pageSize: 99999,
    //     pageNo: 1,
    //     column: "createTime",
    //     order: "desc",
    //     loginType: "store"
    //   };
    //   const { result, code } = await this.$store.dispatch(
    //     "queryAllRoleList",
    //     params
    //   );
    //   if (code == "0") {
    //     this.roleAllList = result.records;
    //   }
    // },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this[formName]));
          params.orgCode = this.detailsRuleForm.orgCodes[
            this.detailsRuleForm.orgCodes.length - 1
          ];
          let list = [];
          this.detailsRuleForm.ruleLists.map(v => {
            list.push({ id: v });
          });
          params.ruleList = list;

          params.loginType = "store";
          this.$store.dispatch("addEmployee", params).then(res => {
            if (res.code == "0") {
              this.innerVisible = false;
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.searchCondition.statusType = "organization";
              this.queryList();
            }
          });
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      for (let key in this[formName]) {
        this[formName][key] = "";
      }
      this.innerVisible = false;
    },
    seleckEmp(row) {
      this.currentRow = row;
      this.saveOkrLeaderChoiceRecord();
      this.$emit("setShopInfo", row);
    },
    add() {
      if (this.selectType === "multiple") {
        if (!this.checkedRowList.length && this.required) {
          this.$message({
            type: "warning",
            message: "请先选择门店"
          });
        } else {
          this.$emit("setMultipleShopInfo", this.checkedRowList);
        }
      } else {
        if (
          (!this.currentRow || !this.currentRow.wecomDeptId) &&
          this.required
        ) {
          this.$message({
            type: "warning",
            message: "请先选择门店"
          });
        } else {
          // this.saveOkrLeaderChoiceRecord();
          this.$emit("setMultipleEmpInfo", [this.currentRow]);
        }
      }
    },
    async queryOkrLeaderChoiceRecordList() {
      const { code, result } = await this.$store.dispatch(
        "queryOkrLeaderChoiceRecordList"
      );
      if (code === "0") {
        this.recordList = result;
      }
    },
    // async saveOkrLeaderChoiceRecord() {
    //   let params = {
    //     leaderId: this.currentRow.employeeId,
    //     leaderName: this.currentRow.realname
    //   };
    //   await this.$store.dispatch("saveOkrLeaderChoiceRecord", params);
    // },
    statusTypeChange(val) {
      this.currentPage = 1;
      // this.pageSize = 10;
      this.active = "";
      this.list = [];
      this.currentRow = {};
      this.tableData = [];
      if (val === "organization") {
        this.queryStoreDepartInfoList();
        this.queryList();
      } else if (val === "role") {
        this.queryAllRoleList();
        this.queryList();
      } else {
        this.querySupervision();
      }
    },
    /**
     * @desc 根据radio值切换 查询左侧树
     *
     */
    async querySupervision() {
      const statusType = this.searchCondition.statusType;
      request({
        method: "post",
        url: this.$serverAdress + `/corp/scrmStaffInfo/queryDeptList`,
        data: {
          queryType: statusType
        }
      }).then(res => {
        const { result } = res;
        this.tableData = result.map(item => {
          if (statusType == "type") {
            item.roleName = item.mopJoiningTraderName;
            item.id = item.wecomDeptId;
          } else if (statusType == "region") {
            item.roleName = item.mopMerchantsAreaName;
            item.id = item.wecomDeptId;
          } else {
            item.roleName = item.mopSupervisorName;
            item.id = item.wecomDeptId;
          }
          return item;
        });
        if (statusType == "guider") {
          this.tableData = arrayUnique2(
            this.tableData,
            "mopSupervisorName"
          ).filter(item => item.mopSupervisorName);
        }
        this.check(this.tableData[0]);
      });
    },
    async queryRoleList() {
      const params = {
        pageSize: 99999,
        pageNo: 1,
        column: "createTime",
        order: "desc",
        loginType: "store"
      };
      const { result } = await this.$store.dispatch("queryRoleList", params);

      const { records } = result;
      this.roleList = records;
    },
    async queryAllRoleList() {
      let params = {
        pageSize: 99999,
        pageNo: 1,
        column: "createTime",
        order: "desc",
        loginType: "store"
      };
      const { result, code } = await this.$store.dispatch(
        "queryAllRoleList",
        params
      );
      if (code == "0") {
        const { records } = result;
        records.forEach(v => {
          v.isShow = false;
          v.departName = v.roleName;
        });
        this.tableData = records;
      }
    },
    handleCurrentChange(row) {
      this.currentRow = row;
    },
    getChecked(selection) {
      this.checkedRowList = selection;
    },
    check() {
      // this.checkItem = item;
      // let list = ["region", "type", "guider", "organization"];
      // if (list.indexOf(this.searchCondition.statusType) > -1) {
      //   this.orgCode = item.wecomDeptId;
      //   this.active = item.wecomDeptId;
      // } else {
      //   this.roleId = item.id;
      //   this.active = this.roleId;
      // }
      this.active = "ACTIVE";
      this.currentPage = 1;
      this.pageSize = 10;
      this.queryList();
    },
    searchAll() {
      this.paramsCondition = {}
      let list = ["organization", "region", "type", "guider"];
      if (list.indexOf(this.searchCondition.statusType) > -1) {
        this.orgCode = "";
        this.currentPage = 1;
        this.active = "";
        this.pageSize = 10;
        this.queryList();
      } else {
        this.roleId = "";
        this.currentPage = 1;
        this.active = "";
        this.pageSize = 10;
        this.queryList();
      }
    },
    // mapTree(arr) {
    //   arr.forEach(items => {
    //     //遍历树
    //     items.show = false;
    //     if (items.children && items.children.length) {
    //       this.mapTree(items.children);
    //     }
    //   });
    // },
    async queryStoreDepartInfoList() {
      // queryStoreDepartInfoList
      const { result } = await this.$store.dispatch(
        "scrmStaffInfoQueryDepartInfo"
      );

      this.tableData = result;
      this.tableData = arrayUnique2(this.tableData, "wecomDeptId");
      console.log("this.tableData.length:", this.tableData.length);
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    async queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        loginType: "store",
        storeCode: this.storeCode,
        ...this.paramsCondition
      };
      // const statusType = this.searchCondition.statusType;
      let list = ["region", "type", "guider", "organization"];
      if (list.indexOf(this.searchCondition.statusType) > -1) {
        // if (["region", "type", "guider"].indexOf(statusType) > -1) {
        //   delete params.deptId;
        //   if (statusType === "region") {
        //     params.mopMerchantsAreaName = this.checkItem.mopMerchantsAreaName;
        //   } else if (statusType === "type") {
        //     params.mopJoiningTraderName = this.checkItem.mopJoiningTraderName;
        //   } else {
        //     params.mopSupervisorName = this.checkItem.mopSupervisorName;
        //   }
        // } else {
        //   params.deptId = this.orgCode;
        // }
        const searchCondition = JSON.parse(
          JSON.stringify(this.searchCondition)
        );
        Object.assign(params, searchCondition);
        let { code, result } = await this.$store.dispatch(
          "scrmStaffInfoQueryDepartInfo",
          params
        );
        if (code === "0") {
          this.list = result;
          console.log("this.list.length:", this.list.length);
          // let { records, total } = result;
          // this.total = total;
          // this.list = records;
          this.isLoading = false
        }
        this.isLoading = false
        this.getModelByParamCode()
      } else {
        params.roleId = this.roleId;
        const searchCondition = JSON.parse(
          JSON.stringify(this.searchCondition)
        );
        Object.assign(params, searchCondition);
        let { code, result } = await this.$store.dispatch(
          "scrmStaffInfoQueryStaffPageList",
          // "queryUserStoreDepartInfoList",
          params
        );
        if (code === "0") {
          let { records, total } = result;
          this.total = total;
          this.list = records;
        }
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    async queryOrganizationTree() {
      let params = {
        pageNo: 1,
        pageSize: 999,
        loginType: "store"
      };
      const { result } = await this.$store.dispatch(
        "queryOrganizationTree",
        params
      );
      result.records.forEach(v => {
        v.leaf = Boolean(!v.isParent);
        v.show = true;
      });

      this.tableData = result.records;
    },
    async queryOrganizationListByParent(node, resolve) {
      const { result } = await this.$store.dispatch(
        "queryOrganizationListByParent",
        {
          parentId: node.treeStruct
        }
      );
      result.forEach(v => {
        v.leaf = Boolean(!v.isParent);
      });
      resolve(result);
      //   console.log(this.organizationList);
    },

    handleOpen(key, keyPath) {
      this.data = this.organizationList[key];
      this.queryOrganizationListByParent(key);
    },
    close() {
      this.$emit("close");
    },
    // 导出
    async handleConfirmExport() {
      // this.$store
      //   .dispatch("scrmStaffInfoQueryDepartInfo", {
      //     // marketingBasicInfoId: "dbd3decbdc0f482cb1ad2a95bf7d20d3",
      //     // storeCode: "42010216070190",
      //     marketingBasicInfoId: this.id,
      //     storeCode: this.storeCode,
      //   })
      //   .then((res) => {
      //     if(res.code == '0'){
      //       this.output(res.result.marketingInfo.canvasTypeData);
      //     }
      //   });
      this.output(this.list)
    },
    // 导出excel
    async output(list) {
      const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
      this.isOutputing = true;
      const tHeader = [
        "企微名称",
        "企微ID",
        "MOP门店名称",
        "MOP门店CODE",
        "MOP门店ID",
      ];

      let filterVal = [
        "wecomDeptName",
        "wecomDeptId",
        "mopCompanyName",
        "mopCompanyCode",
        "mopCompanyId",
      ];

      const data = this.formatJson(filterVal, list);
      exportJsonToExcel(
        tHeader,
        data,
        "门店列表" + new Date().toLocaleString()
      );
      this.isOutputing = false;
    },
    formatJson(filterVal, jsonData) {
      if(jsonData && jsonData.length) {
        return jsonData.map((v) => filterVal.map((j) => v[j]));
      }
      return []
    },
    async refreshStore(){
      this.isLoading = true
      let { code, result } = await this.$store.dispatch(
          "syncDeptList",
          {
            "templateCode": "ADB_COMPANY_INFO"
          }
        );
        if (code === "0") {
          this.queryList()
        }else{
          this.$message({
          message: "刷新失败",
          type: "warning",
          });
          this.isLoading = false
        }
    },
     async getModelByParamCode() {
      const { code, result } = await this.$store.dispatch(
        "getModelByParamCode",
        {
          paramCode: "sync_dept_mop_data_time"
        }
      );
      if (code === "0") {
        this.latestUpdateTime = (result.paramValue).replace(/-/g, '.')
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.bd1 {
  border: 1px solid #dddddd;
  height: 600px;
}
.left {
  width: 240px;
  height: 100%;
  border-right: 1px solid #ddd;
  .node {
    // height: 44px;
    // line-height: 44px;
    padding: 10px 0 10px 10px;
    // padding-left: 30px;
    // padding-right: 10px;
    overflow: hidden;
    font-size: 14px;
    color: #222222;
  }
  .all {
    background: #f7f7f7;
    font-size: 16px;
    color: #222222;
  }
}

.all {
  background: #f7f7f7;
}
.hm-drawer {
  z-index: 9999 !important;
}
</style>
